export const GRAFANA_APP = 'pro_migration';

export const SeamlessModalEventType = {
    EntryPointModalIsShown: 'fip_registration_entry_point_pop_up_is_shown',
    ContactSalesIsShown: 'fip_registration_entry_point_pop_up_contact_sales_is_shown',
    ClickedEntryPointStart: 'clicked_on_fip_registration_entry_point_start',
    ClickedEntryPointClose: 'clicked_on_fip_registration_entry_point_close',
    ClickedContactSalesMeeting: 'clicked_on_fip_registration_contact_sales_meeting',
};
